import { useEffect, type RefObject } from 'react';

/** Calls `handler` when a mousedown/touchstart happens outside `ref`. */
export function useOnClickOutside(
    ref: RefObject<HTMLElement | null>,
    handler: (e: Event) => void,
): void {
    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            if (!ref.current || ref.current.contains(event.target as Node)) {
                return;
            }
            handler(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}
